const featureFlags = {
  // ==========================================
  // Application Core & Infrastructure
  // ==========================================
  // Version management and update control
  herbieDashboardVersion: '0.0.1',
  forceUpdateVersionDashboard: false,

  // UI components and navigation
  sidebar: false,
  toggleFeatureFlag: false,
  sidebarIncidents: false,

  // Developer and debugging tools
  developerTools: false,
  cobler: false,
  impersonate: false,

  // ==========================================
  // Monitoring & Device Tracking
  // ==========================================
  // Device monitoring and status
  activityCompletionStatus: false,
  devicesSlideSseTimeInMs: 10100,
  idleTime: true,
  removedDevice: false,
  showDeviceObservation: false,
  trackingForceVisibilityGeofence: false,

  // ==========================================
  // Fleet Management
  // ==========================================

  sheetImportWithAi: false,

  // Fleet events and tracking
  enableFleetEvents: false,
  enableV2FleetEvents: false,
  libraryExtensionEventSource: false,

  // Driver management and identification
  driverIdentification: false,
  driverSuggestion: false,
  enableDriverAssociationPast: false,
  identifierAssociations: false,
  enableNewUxForDriverImageAssign: false,
  manualDriverImageAssign: false,

  // Vehicle and driver allow lists
  allowList: false,
  enableVehicleDriverAllowList: false,

  // ==========================================
  // Media & Video Features
  // ==========================================
  // Livestream functionality
  livestream: false,
  livestreamPage: false,
  livestreamMulti: false,
  disableLivestreamTimeRestriction: false,
  livestreamConfig: {
    liveTimeout: 60,
    bannerTimeout: 30,
    bannerThreshold: 5,
  },

  // Video playback and events
  videoImpactEvent: false,
  mediaEventLiveUpdate: false,
  videoEnhancedFeatures: false,
  videoEventSeverity: false,
  showObstructionDashboard: false,
  showMatchReview: false,
  multiCamVideoRequests: false,
  multiCamTimelapseRequests: false,
  cobliCamProRecordOff: true,

  // Video configuration
  disableWifiConfiguration: false,
  enforceCameraFeatures: false,

  // AI-powered video features
  aiChat: false,
  aiVideosRecommendations: false,
  aiFilterAnnouncement: false,
  importIdentifierAi: false,
  invertedTokenFleetIds: false,

  // Audio features
  vehiclePopupAudioButton: false,

  // ==========================================
  // Analytics & Reporting
  // ==========================================
  // Fuel card integrations
  fuelCardAlelo: false,
  fuelCardManual: false,
  fuelCardMaxifrota: false,
  fuelCardPrime: false,
  fuelCardSodexo: false,
  fuelCardTicketlog: false,
  fuelCardCtasmart: false,
  enableBrokenFuelCardIntegrationBanner: false,

  // Fuel AI research
  researchFuelAI: false,
  aiFuelOcr: false,

  // Reports and analytics
  showIncidentsReport: false,
  coblinator: false,
  safetyRankingDash: false,

  // ==========================================
  // Pages & Features
  // ==========================================
  // Navigation pages
  heavyUserMap: false,
  roadSpeedPage: true,
  expensesImportButton: true,
  finesPage: false,
  integrationsPage: false,
  businessManager: true,

  // Feature-specific pages
  maintenance: false,
  canUseNonAssociatedVehiclesToRegisterMaintenanceAndTransaction: false,
  prismicAlertsNotAdoptedCohort: false,

  // ==========================================
  // Account & User Experience
  // ==========================================
  // Account configuration
  cadastroDeIdentificadoresOrbital: false,
  ongoingActivationTasks: false,
  announcementCard: false,
  usersNovosAi: false,

  // Contract renewal popup
  contractRenewalConfig: false,

  // ==========================================
  // IoT & Device Control
  // ==========================================
  // Vehicle immobilizer
  enableImmobilizer: false,
  vehicleImmobilizer: false,

  // Remote connection
  useRemoteConnection: false,

  // ==========================================
  // Integrations & External Services
  // ==========================================
  // Address and location services
  internationalAddressAutocomplete: false,

  // Communication services
  blipChat: false,

  // ==========================================
  // Development & Monitoring Tools
  // ==========================================
  // Datadog RUM (Real User Monitoring)
  ddRumSampleRate: 100,
  ddRumReplaySampleRate: 0,
  useDdRum: false,

  // Push notifications
  oneSignal: false,

  // ==========================================
  // AI Recommendations
  // ==========================================
  aiRecommendations: false,

  // Temporary flags
  showWarningBanner: false,
};

type FeatureFlags = typeof featureFlags;

export { featureFlags };
export default FeatureFlags;
